module.exports = __webpack_public_path__ + "static/img_2544_optimized-6c283175689ef167c5a41a1e79a6600d.jpg";